var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-slide-item"},[_vm._t("default",function(){return [_c('a',{attrs:{"href":_vm.item.url}},[_c('img',{attrs:{"src":_vm.item.image}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }